<template>
  <div style="height: 100%;overflow: auto;">
    <el-table :data="list" border stripe>
      <el-table-column label="ID" prop="id" width="80px"></el-table-column>
      <el-table-column label="绑定微信用户">
        <template v-slot="scope">
          <div class="wx-user" v-if="scope.row.user">
            <div class="avatarurl" :style="{ backgroundImage:'url('+scope.row.user.avatarurl+')' }"></div>
            <div class="nickname">{{scope.row.user.nickname}}</div>
          </div>
          <div class="wx-user" v-if="!scope.row.user">
            暂无绑定用户
          </div>
        </template>
      </el-table-column>
      <el-table-column label="申请人" prop="name"></el-table-column>
      <el-table-column label="手机号码" prop="phone"></el-table-column>
      <el-table-column label="地址" prop="">
        <template slot-scope="scope"> {{scope.row.city}}{{scope.row.address}} </template>
      </el-table-column>
      <el-table-column label="申请时间" prop="addtime_format"></el-table-column>
      <el-table-column label="审核状态" prop="">
        <template v-slot="scope">
          <el-tag type="success" size="small" v-if="scope.row.is_pass==1">通过</el-tag>
          <el-tag type="info" size="small" v-if="scope.row.is_pass==0">未审核</el-tag>
          <el-tag type="danger" size="small" v-if="scope.row.is_pass==2">不通过</el-tag>
          <template v-if="scope.row.is_pass ==0">
            <el-popconfirm title="确定审核通过？" @confirm="join_check(scope.row.id,'1')">
              <el-button slot="reference" type="text" size="small" class="ml-10">通过</el-button>
            </el-popconfirm>
            <el-popconfirm title="确定不通过？" @confirm="join_check(scope.row.id,'2')">
              <el-button type="text" size="small" slot="reference" class="ml-10">不通过</el-button>
            </el-popconfirm>
          </template>
        </template>
      </el-table-column>
      <el-table-column label="审核时间" prop="check_time_format"></el-table-column>
      <el-table-column label="操作" width="220px">
        <template v-slot="scope">
          <!--          <el-button type="primary" @click="admin_edit(scope.row.id)" size="small" style="margin-right: 10px;">编辑</el-button>-->
          <el-popconfirm title="确认删除？" @confirm="join_check(scope.row.id,'1')" v-if="scope.row.is_pass==2">
            <el-button type="success" size="small" slot="reference" style="margin-right: 10px;">重新通过</el-button>
          </el-popconfirm>
          <el-popconfirm title="确认删除？" @confirm="join_del(scope.row.id)">
            <el-button type="danger" size="small" slot="reference">删除</el-button>
          </el-popconfirm>
        </template>
      </el-table-column>
    </el-table>
    <div style="height: 60px;"></div>
    <layer-page :total="total" :page-size="20"></layer-page>
  </div>
</template>

<script>
import LayerPage from "@/components/layer-page";
export default {
name: "join",
  components:{LayerPage},
  data(){
    return{
      list:[],
      is_load:false,
      page:1,
      total:0,
    }
  },
  mounted : async function(){
    try{
      await this.get_list();
    }catch (e){
      console.log(e);
      return false;
    }
  },
  methods: {
    get_list: async function () {
      if (!this.is_load) {
        this.is_load = true;
        this.$_showLoading();
        let res = await this.$_api.ebook('get_join_list', {page: this.page,uid:this.user.uid});
        this.is_load = false;
        this.$_hideLoading();
        this.list = res.list;
        this.total = res.total;
      }
    },
    join_check: async function (id, val) {
      try {
        this.$_showLoading();
        let res = await this.$_api.ebook('check', {id: id, val: val});
        this.$_hideLoading();
        this.$_showToast(res.errmsg, res.style);
        if (res.errcode == 0) {
          await this.get_list();
        }
      } catch (e) {
        console.log(e);
      }
    },
  }
}
</script>

<style scoped>
.wx-user { display: flex; height: auto; overflow-x: hidden; vertical-align: middle; line-height: 30px; }
.avatarurl { width: 30px; height: 30px; border-radius: 20px; overflow-x: hidden; background: #f2f2f2 no-repeat center; background-size: cover; }
.nickname { padding-left: 15px; font-size: 14px; line-height: 30px;flex: 1 }
.cover{width: 100px;height: 50px;background: #f2f2f2 no-repeat center;background-size: cover; }
</style>